import { render } from "./WindowConsumables.vue?vue&type=template&id=07f801a5"
import script from "./WindowConsumables.vue?vue&type=script&lang=js"
export * from "./WindowConsumables.vue?vue&type=script&lang=js"

import "./WindowConsumables.vue?vue&type=style&index=0&id=07f801a5&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__